import React from 'react';
import { twMerge } from 'tailwind-merge';

import Select from 'react-select';

export const MultiSelect = ({
  values,
  formName,
  currentlySelected,
  maxAllowed,
  minAllowed,
  className,
  onChange,
  ariaLabelledBy,
  ariaLabel,
}) => {
  const handleChange = (newValue, actionMeta) => {
    if (newValue.length < minAllowed && actionMeta.action === 'remove-value') {
      return;
    }

    onChange(newValue);
  };

  return (
    <Select
      isMulti
      options={values}
      value={currentlySelected}
      isOptionDisabled={(option, selectValue) =>
        maxAllowed ? selectValue.length >= maxAllowed : false
      }
      name={formName}
      required={minAllowed > 0}
      aria-labelledby={ariaLabelledBy}
      aria-label={ariaLabel}
      // customize colors
      className={twMerge('react-select-container', className)}
      classNamePrefix="react-select"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          // nearest colors from tailwind
          primary: '#3B82F6',
          primary75: '#60A5FA',
          primary50: '#BFDBFE',
          primary25: '#DBEAFE',
          danger: '#460809',
          dangerLight: '#FDA4AF',
        },
      })}
      onChange={handleChange}
    />
  );
};
